import React, { useEffect } from "react";
import ResourcesTab from "./ResourcesTab";
import { staticURLs } from "../../config/urls";
import LogoContainer from "../common/LogoContainer";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { useTranslation } from "react-i18next";

const JunkMailAndCalls = () => {
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const { t: tLang } = useTranslation();

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="resources-junkmailandcalls-page">
                        Resources
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ResourcesTab selectedTab="9" />

            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName="trash" />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">{tLang("resourcesSection.junkMailAndCallTab.title")}</h2>
                                </div>
                            </div>
                            <div className="box-description">
                                <p>
                                    {tLang("resourcesSection.junkMailAndCallTab.content")}
                                 
                                </p>
                            </div>
                            <div className="box-actions"></div>
                        </div>

                        <div className="box-content">
                            <div className="resource-container">
                                <a
                                    target="_blank"
                                    href={staticURLs.optOutOfPrescreenedCreditCardOffers}
                                    onClick={() => window.addToDataLayer({ event: "Opt out of Prescreened Credit Card Offers" })}
                                    className="resource-link"
                                    rel="noreferrer"
                                >
                                    <span className="resource-icon">
                                        <RenderIcons iconName="credit-card" width="28" color="#00313C " />
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.junkMailAndCallTab.listText1")}</span>
                                    </span>
                                </a>
                            </div>
                            <div className="resource-container">
                                <a
                                    target="_blank"
                                    href={staticURLs.telemarketingPhoneCalls}
                                    onClick={() => window.addToDataLayer({ event: "Telemarketing Phone Calls" })}
                                    className="resource-link"
                                    rel="noreferrer"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-phone-volume"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.junkMailAndCallTab.listText2")}</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    target="_blank"
                                    href={staticURLs.commercialEmails}
                                    onClick={() => window.addToDataLayer({ event: "Commercial Emails" })}
                                    className="resource-link"
                                    rel="noreferrer"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-at"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.junkMailAndCallTab.listText3")}</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    target="_blank"
                                    href={staticURLs.commercialMailDMAchoice}
                                    onClick={() => window.addToDataLayer({ event: "Commercial Mail (DMAchoice)" })}
                                    className="resource-link"
                                    rel="noreferrer"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-envelope"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.junkMailAndCallTab.listText4")}</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    target="_blank"
                                    href={staticURLs.commercialMailLexisNexis}
                                    onClick={() => window.addToDataLayer({ event: "Commercial Mail (Lexis Nexis)" })}
                                    className="resource-link"
                                    rel="noreferrer"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-envelope"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.junkMailAndCallTab.listText5")}</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    target="_blank"
                                    href={staticURLs.commercialCouponsValpak}
                                    onClick={() => window.addToDataLayer({ event: "Commercial Coupons (Valpak)" })}
                                    className="resource-link"
                                    rel="noreferrer"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-ticket-alt"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.junkMailAndCallTab.listText6")}</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container" style={{ display: "none" }}>
                                <a
                                    target="_blank"
                                    href={staticURLs.commercialCouponsRetailMeNot}
                                    onClick={() => window.addToDataLayer({ event: "Commercial Coupons (RetailMeNot)" })}
                                    className="resource-link"
                                    rel="noreferrer"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-ticket-alt"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.junkMailAndCallTab.listText7")}</span>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default JunkMailAndCalls;
